/*
    sidebar component should be a component usable for all main views
*/
import React, { useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import { $ } from "../../../../../vendor";
import { getAllUrlParams } from "../../../../utils";
import NewAbonnementButton from "./NewAbonnementButton";

const AbonnementsSidebar = (props: any) => {
  const { initialized, setFilter, filterChangedHandle, setAdd } = props;

  const allUrlParams = getAllUrlParams(window.location.href);
  const cleanState = {};
  const [usedFilterCount, setUsedFilterCount] = useState({});
  const [filterCount, setFilterCount] = useState(
    Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0,
  );

  const [initialState, setInitialState] = useState(initialized);
  const [typeFilter, setTypeFilter] = useState([
    { name: t("all"), value: "all", dataKey: "state_all" },
  ]);
  const onToggleLeftBar = (ev: any) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };
  const onFilterCountChangeHandle = (value: any) => {
    let clone = { ...value };
    let count = 0;
    for (const [type, val] of Object.entries(clone)) {
      if (val) {
        count++;
      }
    }
    if (count < 1) {
      count = 0;
      $("#inb-selected-filters").addClass("hidden");
    } else {
      $("#inb-selected-filters").removeClass("hidden");
    }
    setFilterCount(count);
  };

  const resetFilter = (e: any, disp: boolean = true) => {
    let clone = {
      find: "full",
    };
    setFilterCount(0);
    setFilter(clone);
    setUsedFilterCount(cleanState);
    onFilterCountChangeHandle(cleanState);
    if (disp) {
      filterChangedHandle(clone, {
        sort: "name",
        direction: "asc",
      });
    } else {
      setFilter(clone);
    }
    const newRelativePathQuery = window.location.pathname;
    history.pushState(null, "", newRelativePathQuery);
  };

  const addAbonnement = () => {
    setAdd(true);
  };

  return (
    <aside id="inb-c-sidebar" className="contingent-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title sticky-top">
        <h1 className="inb-page-title">{t("abonnements", null, "capital")}</h1>
      </header>
      {initialState && (
        <>
          {" "}
          <aside id="inb-selected-filters">
            {filterCount > 0 && (
              <ul>
                <p>
                  <i className="fi fi-filter"> </i>
                  <span id="inb-selected-filters__count">{" " + filterCount}</span>

                  {" " + t("filter_selected")}
                  <a
                    href="#"
                    id="inb-selected-filters__unset"
                    className="unset-filter"
                    title={t("unselect_all_filter")}
                    onClick={(e: any) => {
                      resetFilter(e);
                    }}
                  >
                    x
                  </a>
                </p>
              </ul>
            )}
          </aside>
          <div className="sticky-top-filter">
            <hr />

            {/*  <ul id="inb-c-left-bar-flist--contingent-locations"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('location',null,'capital')}
                </span>
                <select
                    className="inbooma-select-box__input"
                    name="locations"
                    onChange={(e) => onLocationFilterChange(e)}
                    value={locationFilter}
                    placeholder={t('select_${a}',{a:t('location')})}>
                    {locations.map(location => {
                        return(
                            <>
                                <option key={location.id} value={location.id}>{location.name}</option>
                            </>
                        )
                    })}
                </select>
                {locationFilter !== undefined && locationFilter !== null &&
                    <a href="#" className="inbooma-select-box__reset" onClick={() => onLocationFilterChange('all')} style={{float:'unset', paddingLeft:'15px'}}>
                        x
                    </a>
                }
            </ul>*/}
          </div>
        </>
      )}
      {rbac.hasPermission("addAbonnement") && (
        <footer
          className="inb-c-left-bar__footer small-only-float-container"
          data-inb-action-link="write"
        >
          <a
            href="#"
            id="toggle-left-bar"
            className="button secondary show-for-small-only"
            onClick={(e) => onToggleLeftBar(e)}
          >
            <i className="fi fi-filter"> </i>
            <span className="show-for-sr">{t("open_filter_menu")}</span>
          </a>
          <NewAbonnementButton addAbonnement={addAbonnement} />
        </footer>
      )}
    </aside>
  );
};

export default AbonnementsSidebar;
